<template>
  <div class="right_box_main">
    <!-- 面包屑导航 -->

    <div class="card-box">
      <!-- 右边卡片 -->
      <div class="card-rb">
        <div class="card-4">
          <el-card :body-style="{ padding: '16px' }">
            <div class="fisthang">
              <el-form
                :inline="true"
                :model="searchlist"
                class="demo-form-inline"
                size="mini"
              >
                <el-form-item
                  label="任务名称:"
                  style="margin:0 10px 0 0;"
                >
                  <el-input
                    v-model="searchlist.name"
                    placeholder="请输入任务名称"
                    style="width:200px"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="所属区域:"
                  style="margin:0 10px 0 0;"
                >
                  <el-cascader
                    v-model="searchlist.orgId"
                    :options="orgList"
                    @change="handleChange"
                    :show-all-levels="false"
                  ></el-cascader>
                </el-form-item>
                <el-form-item>
                  <el-button
                    type="primary"
                    @click="searchlistdata"
                  >查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button
                    type="info"
                    @click="searchlistReset"
                  >重置</el-button>
                </el-form-item>
              </el-form>
            </div>
            <div class="three">
              <el-button
                type="primary"
                size="mini"
                @click="showDialogForm('','add')"
              >新增</el-button>
            </div>
            <!-- 表格盒子 -->
            <div class="table_card">
              <el-table
                :data="tableData"
                :header-cell-style="{ background: '#f8fafa' }"
                border
                align="center"
              >
                <!-- <el-table :data="tableData" :header-cell-style="{ background: '#f8fafa' }"
                border align="center" @row-click="changeColor" :row-style="selectedHighlight" >-->
                <!-- <el-table-column type="selection" align="center"></el-table-column> -->
                <el-table-column
                  type="index"
                  align="center"
                  label="序号"
                  width="50"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="id"
                  label="任务编号"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="name"
                  label="任务名称"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="content"
                  label="任务内容"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="orgIdCn"
                  label="所属机构"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="place"
                  label="具体位置"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="times"
                  label="添加时间"
                ></el-table-column>
                <el-table-column
                  align="center"
                  label="操作"
                  fixed="right"
                >
                  <template slot-scope="scope">
                    <el-tooltip
                      class="item"
                      effect="light"
                      content="修改"
                      placement="top-start"
                      v-if="orgLevel!==4"
                    >
                      <button
                        class="iconfont icon-bianji3 tabBtn"
                        @click="showDialogForm(scope.row.id,'edit')"
                      ></button>
                    </el-tooltip>
                    <el-tooltip
                      class="item"
                      effect="light"
                      content="点击下载"
                      placement="top-start"
                    >
                      <button
                        class="el-icon-download tabBtn"
                        @click="download(scope.row)"
                      ></button>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                :page-size="pageConfig.pageSize"
                layout="total, prev, pager, next, jumper"
                @current-change="handleCurrentChange"
                :total="pageConfig.total"
              ></el-pagination>
            </div>
          </el-card>
        </div>
      </div>
    </div>
    <!-- 弹出框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="showadd"
      width="1100px"
      :before-close="clearadddata"
    >
      <el-form
        ref="baseForm"
        :rules="rules"
        :model="baseForm"
        label-width="110px"
        size="mini"
      >
        <el-form-item
          label="任务名称："
          prop="name"
        >
          <el-input
            :disabled="editDisable"
            v-model="baseForm.name"
            placeholder="请输入任务名称"
            style="width: 50%;"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="具体位置："
          prop="place"
        >
          <el-input
            :disabled="editDisable"
            v-model="baseForm.place"
            placeholder="请输入选择位置"
            style="width: 50%;"
            @blur="transLocation"
          ></el-input>
          <div
            id="mapDome"
            style="width:60%;height:200px;margin-top:10px"
          ></div>
        </el-form-item>
        <el-form-item
          label="所属机构："
          prop="releaseDate"
        >
          <el-cascader
            v-model="baseForm.orgId"
            :options="orgList"
            @change="handleChange1"
            :show-all-levels="false"
          ></el-cascader>
        </el-form-item>
        <el-form-item
          label="任务内容："
          prop="content"
        >
          <el-input
            type="textarea"
            v-model="baseForm.content"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="boontbtn">
        <el-button
          type="primary"
          size="small"
          style="margin: 0 30px"
          @click="saveadddata"
        >保存</el-button>
        <el-button
          type="info"
          size="small"
          @click="clearadddata"
        >关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { post, get } from "@/api/requrestHttp.js"
import editor_option from "../../../utils/editorOption.js"
import request from "../../../utils/request.js"
import request2 from "../../../utils/request2.js"
import AMap from "AMap" // 引入高德地图
export default {
  data() {
    return {
      orgList: [],
      dialogTitle: "新增",
      // 新增弹出层
      flag: "add",
      showadd: false,
      editDisable: false,
      showSaveBtn: true,
      baseForm: {},

      rules: {
        policyConsultationType: [
          { required: true, message: "请选择咨询类别", trigger: "blur" },
        ],
        name: [{ required: true, message: "请输入咨询标题", trigger: "blur" }],
        content: [
          { required: true, message: "请输入咨询内容", trigger: "blur" },
        ],
        releaseDate: [
          { required: true, message: "请选择发布时间", trigger: "blur" },
        ],
        status: [
          { required: true, message: "请选择发布状态", trigger: "blur" },
        ],
      },
      // 查询
      queryTime: [],
      searchlist: {},
      tableData: [],
      pageConfig: {
        pageSize: 10,
        total: 0,
        pageNo: 1,
      },
      status: true,
      activityAddress: {},
      baseForm: {},
      option4: [],
      option5: [],
      option6: [],
      orgLevel: "",
    }
  },
  created() {
    post("/rbac/admin/org/info/OrgTreelist", { orgType: 1,isValid: 1, }).then((res) => {
      this.orgList = res.content
    })
  },
  methods: {
    getOrgLevel() {
      post("admin/user/info/getLoginUserInfo", {
        id: this.$store.state.id,
      }).then((res) => {
        if (res.code == 200) {
          // this.userName=res.content.user.name;
          this.orgLevel = res.content.user.orgLevel
        } else {
          this.$message.error(res.message)
        }
      })
    },
    async download(row) {
      var res = await request2({
        url: "/admin/task/info/openEwm",
        method: "GET",
        params: { id: row.id },
        responseType: "blob",
      })
      console.log(res)
      const blob = new Blob([res], { type: "image/png" })
      const fileName = row.place
      const linkNode = document.createElement("a")
      linkNode.download = fileName //a标签的download属性规定下载文件的名称
      linkNode.style.display = "none"
      linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
      document.body.appendChild(linkNode)
      linkNode.click() //模拟在按钮上的一次鼠标单击

      URL.revokeObjectURL(linkNode.href) // 释放URL 对象
      document.body.removeChild(linkNode)
    },
    handleChange(value) {
      // console.log(val)
      if (value != null) {
        this.searchlist.orgId = value[value.length - 1]
      }
    },
    handleChange1(value) {
      //console.log(val)
      if (value != null) {
        this.baseForm.orgId = value[value.length - 1]
      }
    },
    //条件查询
    searchlistdata() {
      this.pageConfig = {
        pageSize: 10,
        pageNo: 1,
      }
      this.getPageDatas()
    },
    searchlistReset() {
      this.searchlist = {}
      this.pageConfig = {
        pageSize: 10,
        total: 0,
        pageNo: 1,
      }
      this.getPageDatas()
    },
    //分页
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val
      this.getPageDatas()
    },
    //获取列表数据
    async getPageDatas() {
      if (this.queryTime.length > 0) {
        this.searchlist.startTime = this.queryTime[0]
        this.searchlist.overTime = this.queryTime[1]
      }
      var res = await request({
        url: "/admin/task/info/findTaskList",
        method: "POST",
        data: {
          ...this.searchlist,
          ...this.pageConfig,
        },
      })
      if (res.code == 200) {
        this.pageConfig.total = res.content.count
        this.tableData = res.content.list
      } else {
        this.$message({
          message: "数据加载异常：",
          type: "error",
        })
      }
    },

    async showDialogForm(id, flag) {
      this.flag = flag
      if (id != "") {
        if (flag == "edit") {
          this.editDisable = false
          this.showSaveBtn = true
          this.dialogTitle = "编辑"
        }
        //获取编辑项的最新数据
        let data = {}
        data.id = id
        var res = await request({
          url: "/admin/task/info/getTask",
          method: "POST",
          data: data,
        })
        if (res.code == 200) {
          this.baseForm = res.content
          this.showadd = true
          //   console.log(res.content.orgId)
          this.baseForm.orgId = res.content.orgId + ""
          this.$nextTick(() => {
            this.mapInit("mapDome")
          })
        } else {
          this.$message({
            message: "数据项加载异常",
            type: "error",
          })
          this.showadd = false
        }
      } else {
        this.editDisable = false
        this.showApprove = false
        this.showSaveBtn = true
        this.showadd = true
        this.dialogTitle = "新增"
        this.baseForm = {}
        this.$nextTick(() => {
          this.mapInit("mapDome")
        })
      }
    },

    //获取新增所有数据发请求
    async saveadddata() {
      let url = "/admin/task/info/updateTask"
      if (this.flag == "add") {
        url = "/admin/task/info/insertTask"
      }

      var res = await request({
        url: url,
        method: "POST",
        data: {
          ...this.baseForm,
        },
      })
      if (res.code == 200) {
        this.$message({
          message: this.dialogTitle + "成功",
          type: "success",
        })
        this.showadd = false
        this.getPageDatas()
      } else {
        this.$message({
          message: this.dialogTitle + "失败：" + res.message,
          type: "error",
        })
      }
    },
    // 新增弹出框重置
    clearadddata() {
      this.showadd = false
    },
    //删除操作
    async showdeletepanduan(id) {
      this.$confirm("此操作将删除该信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let data = {}
          data.id = id
          var res = await request({
            url: "/policyConsultation/info/deletePolicyConsultation",
            method: "POST",
            data: data,
          })
          if (res.code == 200) {
            this.$message({
              message: "删除成功",
              type: "success",
            })
            this.showadd = false
            this.getPageDatas()
          } else {
            this.$message({
              message: "删除失败：" + res.message,
              type: "error",
            })
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          })
        })
    },
    //根据输入地址转换经纬度并标记
    transLocation(e) {
      const that = this
      let geocoder = new AMap.Geocoder({
        radius: 1000,
        extensions: "all",
      })

      geocoder.getLocation(this.baseForm.place, (status, result) => {
        if (status === "complete" && result.geocodes.length) {
          let lnglat = result.geocodes[0].location
          this.baseForm.longitude = lnglat.lng
          this.baseForm.latitude = lnglat.lat
          this.setmarkerFunc(lnglat.lng, lnglat.lat)
        } else {
          this.$message({
            message: "获取坐标失败，请手动获取",
            type: "error",
          })
          this.baseForm.longitude = ""
          this.baseForm.latitude = ""
          //   this.baseForm.addressDetail = "";
          this.$set(this.baseForm, "place", "")
        }
      })
      //this.onSuccess(this.baseForm);
    },
    setmarkerFunc(longitude, latitude) {
      this.mapmarker.setPosition([longitude, latitude])
      this.mapcontainer.add(this.mapmarker)
      this.mapcontainer.setFitView(this.mapmarker)
    },
    //初始化地图插件的方法
    mapInit(containerId) {
      this.mapcontainer = new AMap.Map(containerId, {
        resizeEnable: true,
        zoom: 18,
        zooms: [3, 20],
        expandZoomRange: true,
      })
      this.mapmarker = new AMap.Marker({
        //position: [this.baseForm.longitude, this.baseForm.latitude],
        map: this.mapcontainer,
      })

      this.mapcontainer.plugin("AMap.Geolocation", () => {
        this.geolocation = new AMap.Geolocation({
          enableHighAccuracy: true, //是否使用高精度定位，默认:true
          timeout: 10000, //超过10秒后停止定位，默认：无穷大
        })
        this.mapcontainer.addControl(this.geolocation)

        this.geolocation.getCurrentPosition()

        AMap.event.addListener(this.geolocation, "complete", (data) => {
          this.setmarkerFunc(this.baseForm.longitude, this.baseForm.latitude)
        }) //返回定位信息
      })

      //定义地图坐标点击事件
      this.mapcontainer.on("click", (e) => {
        // console.log(e);

        this.baseForm.longitude = e.lnglat.getLng()
        this.baseForm.latitude = e.lnglat.getLat()
        this.setmarkerFunc(this.baseForm.longitude, this.baseForm.latitude)
        // 这里通过高德 SDK 完成。
        var geocoder = new AMap.Geocoder({
          radius: 1000,
          extensions: "all",
        })

        geocoder.getAddress(
          [this.baseForm.longitude, this.baseForm.latitude],
          (status, result) => {
            if (status === "complete" && result.info === "OK") {
              if (result && result.regeocode) {
                // this.baseForm.addressDetail = result.regeocode.formattedAddress;
                this.$set(
                  this.baseForm,
                  "place",
                  result.regeocode.formattedAddress
                )
                //this.onSuccess(this.baseForm);
              }
            }
          }
        )
        this.setmarkerFunc(this.baseForm.longitude, this.baseForm.latitude)
      })
    },
  },
  mounted() {
    this.getPageDatas()
    this.getOrgLevel()
  },
}
</script>

<style lang="less" scoped>
// 表格的盒子
.table_card {
  // overflow: hidden;
  // 解决表格无法自适应宽度
  // width: calc(100vw - 500px);
  margin: 16px 0 0 0;
  .el-table {
    width: 100%;
    // 表格里的按钮
    .tabBtn {
      margin: 0 6px;
    }
    .tabBtn:nth-child(1) {
      color: #199b5d;
      font-size: 22px;
    }
    .tabBtn:nth-child(2) {
      color: #ff04ed;
      // font-size: 25px;
    }
    .tabBtn:nth-child(3) {
      color: #dd3020;
      // font-size: 25px;
    }
    .tabBtn:nth-child(5) {
      color: #e400ff;
      font-size: 22px;
    }
    .tabBtn:nth-child(4) {
      color: #2e99cf;
      // font-size: 25px;
    }
    .active_Btn {
      color: #ff04ed !important;
      // font-size: 25px;
    }
  }
}
</style>